module.exports = __webpack_public_path__ + "static/doctor_icon-c7e6a3795e9dda3fd25b9d3f8e342c69.png";